// extracted by mini-css-extract-plugin
export var submit = "styles-module__submit___Yqowu";